var exports = {
  "KF": "ChessPromotionPicker.module__promotion___NmZ6RD",
  "e6": "ChessPromotionPicker.module__promotionLabel___NmZ6RD",
  "pc": "ChessPromotionPicker.module__promotionChoice___NmZ6RD",
};

module.exports = exports;
